<template>
  <div class="button-group-wrapper">
    <div
      v-for="(button, index) in buttons"
      :id="`sources-${button.text}-${index+1}`"
      :key="index+1"
      class="single-button-container tooltip"
      :class="{'compact-screen-source-button-container': !isChatWidgetFullScreen}"
      @click.stop="handleButtonClicked"
    >
      <span class="tooltiptext">{{ button.url }}</span>
      <button
        class="single-button tab-focused-btn"
        :class="{'compact-screen-source-single-button': !isChatWidgetFullScreen}"
      >
        <div class="single-button-content">
          <BaseIcon
            :name="button.image || 'DescriptionIcon'"
            height="20px"
            width="20px"
            fill="#6D6D6D"
          />
          <p
            :style="{ ...getFontSizeForResponse('bodyText', false) }"
            class="button-text"
          >
            {{ getTruncatedText(button.text) }}
          </p>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/views/BaseIcon.vue'
import fontSizeMixin from '@/mixins/fontSizeMixin'

export default {
	name: 'ButtonGroup',
    components: {
        BaseIcon
    },
    mixins: [fontSizeMixin],
    props: {
        buttons: {
            type: Array,
            default: () => [],
        },
        truncateValue: {
            type: Number,
            default: 35
        }
    },
    computed: {
        isChatWidgetFullScreen() {
            return this.$store.state.isChatWidgetFullScreen
        },
    }, 
    methods: {
        handleButtonClicked(event) {
            const clickedButtonIndex = event.target.parentNode.id.split('-').at(-1) - 1
            const link = this.buttons[clickedButtonIndex]?.url
            link && window.open(link, 'noopener', 'noreferrer')
        },
        getTruncatedText(text) {
            return `${text.substring(0, this.truncateValue)}${text.length > this.truncateValue ? '...' : ''}`
        }
    }
}
</script>
<style lang="scss" scoped>
.button-group-wrapper {
    display: flex;
    flex-flow: row wrap;
    -webkit-flex-flow: row wrap;
    gap: 8px;

    .single-button-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        &.compact-screen-source-button-container {
            max-width: 300px;
        }

        .single-button {
            cursor: pointer;
            background: none;
            border: 1px solid #E8E8E8;
            border-radius: 4px;
            transition: 0.3s all ease-in-out;

            &.compact-screen-source-single-button {
                text-overflow: clip;
                overflow: hidden;
                max-width: 300px;
            }
            .single-button-content {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 8px;
                padding: 6px 12px 6px 8px;
                pointer-events: none;
                .button-text {
                    font-weight: 400;
                    color: #2C2C2C;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }

            &:hover {
                background-color: var(--button-links-hover-background-color);
                outline: none;
                border: 1px solid var(--user-chat-color);
            }
        }

    }
    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltiptext {
        bottom: 120%;
        max-width: 300px;
        text-overflow: visible;
        padding: 8px !important;
        overflow-wrap: break-word;
        box-sizing: border-box;
        pointer-events: none;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        background-color: black;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 0;
        position: absolute;
        z-index: 2147483647;
    }

    .tooltip .tooltiptext::after {
        content: "";
        position: absolute;
        border-width: 5px;
        border-style: solid;
        border-color: black transparent transparent transparent;
        left: 50%;
        bottom: -10px;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }
}
</style>
